// extracted by mini-css-extract-plugin
export default {"productImgContainer":"productImgContainer__3zmRH","productImg":"productImg__3lOyY"};
    if(module.hot) {
      // 1764953366832
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  